import React from 'react'
import Image, { StaticImageData } from 'next/image'
import { useHover } from 'react-use'
import { Clickable } from '../bases/Clickable'
import { HStack } from '../bases/HStack'
import { Text } from '../bases/Text'
import { VStack } from '../bases/VStack'
import ExtenalLinkIconActive from '../../../../public/images/iconExternalLinkActive.png'
import ExtenalLinkIcon from '../../../../public/images/iconExternalLink.png'
import { useTranslation } from 'react-i18next'

export type Props = {
  normalIconUrl?: StaticImageData
  activeIconUrl?: StaticImageData
  isActive?: boolean
  disabled?: boolean
  commingSoon?: boolean
  text: string
  isExtenalLink?: boolean
  onClick?: () => void
}

export const GlobalMenuButton: React.FC<Props> = (props) => {
  const { t } = useTranslation()
  const [hoverable] = useHover((hovered) => {
    const isActive = props.isActive || hovered
    return (
      <Clickable className="w-full" disabled={props.disabled} onClick={props.onClick}>
        <VStack
          className={`w-full items-start rounded-lg p-3 transition-all ${
            isActive || hovered ? 'bg-primary-textActive bg-opacity-10' : ''
          }`}
        >
          <HStack className={props.disabled ? 'opacity-40' : ''}>
            {props.activeIconUrl && props.normalIconUrl ? (
              <Image
                src={isActive ? props.activeIconUrl : props.normalIconUrl}
                width={20}
                height={20}
                objectFit="contain"
                alt={props.text}
              />
            ) : null}
            <HStack className="ml-2 items-center">
              <Text className={`text-sm font-bold ${isActive ? 'text-primary-textActive' : 'text-white'} `}>
                {props.text}
              </Text>

              {props.isExtenalLink ? (
                <div className="ml-2 flex">
                  <Image
                    src={isActive ? ExtenalLinkIconActive : ExtenalLinkIcon}
                    width="16px"
                    height="16px"
                    objectFit="contain"
                    alt="External Link Icon"
                  />
                </div>
              ) : null}
            </HStack>
          </HStack>
          {props.commingSoon ? (
            <Text className="ml-8 text-sm font-semibold text-primary-textActive">
              {t('Common.comingSoon')}
            </Text>
          ) : null}
        </VStack>
      </Clickable>
    )
  })
  return hoverable
}
